import React from 'react';
import clientInformation from '../login/ClientInfo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy } from '@fortawesome/free-solid-svg-icons'
import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Alerts from '../helpers/Alerts';
import Loading from '../helpers/Loader';
import { IsValidToken, CheckCustomerData } from "../../services/AuthenticationService";
import { useParams } from 'react-router-dom';
import { onlyNumbers, BonusString } from '../helpers/common';
import { EWalletDeposit, CoinflowGetCheckoutSession } from "../../services/DepositService";
import Bonus from '../Bonus';
import { isMobile } from 'react-device-detect';
import { MissingAccountInfo } from "../deposit/MissingAccountInfo.jsx";
import iframeResizer from 'iframe-resizer';
import { CoinflowPurchase } from '@coinflowlabs/react';

export const CoinFlowMethods = () => {
    const clientInfo = clientInformation();
    let MAXLIMIT = process.env.REACT_APP_MaxLimit;
    let INSTANCEID = clientInfo.InstanceID;
    let url = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
    const { id } = useParams();
    const [arrayRegularDeposits, setRegularDeposits] = useState(JSON.parse(localStorage.getItem('ArrayRegularMethods')).filter(function (element) { return element.DepositID == id; })[0]);
    const navigate = useNavigate();
    const [isProcessing, setIsProcessing] = useState(false);
    const [showiFrame, setshowiFrame] = useState(false);
    const [showFrameTitle, setShowFrameTitle] = useState(true);
    const [showForm, setshowForm] = useState(true);
    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [arrayEwallet, setArrayEwallet] = useState([]);
    const [isValidate, setIsValidate] = useState(true);
    const [isSecureIdVisible, setIsSecureIdVisible] = useState(false);
    const [isAccountVisible, setIsAccountVisible] = useState(false);
    const [height, setHeight] = useState('500px');
    const iframeRef = React.useRef(null);
    const lastHeightRef = React.useRef(0);
    const debounceTimeout = React.useRef(null);
    const [isCoinflow, setIsCoinflow] = useState(false);
    const [coinflowSession, setCoinflowSession] = useState(null);
    const [coinflowHeight, setCoinflowHeight] = useState(800);
    const [showWidget, setshowwidget] = useState(false);


    useEffect(() => {
        IsValidToken(localStorage.getItem('Token')).then(function (response) {
            validateFields();
            doCheckCustomerData();

        })
            .catch(function (error) {
                navigate('/expired/');
            })
        if (arrayRegularDeposits == undefined) {
            navigate('/deposits/');
        }

        const handleMessage = (event) => {
            // Optional: Validate origin
            // if (event.origin !== 'https://trusted-site.com') return;

            const data = event.data;
            if (data && data['full-content-height']) {
                setShowFrameTitle(false);
                const newHeight = parseInt(data['full-content-height'], 10);

                // Clamp to reasonable range (e.g., 300px to 900px)
                if (newHeight < 300 || newHeight > 900) return;

                // Debounce to avoid rapid resizing
                if (debounceTimeout.current) {
                    clearTimeout(debounceTimeout.current);
                }

                debounceTimeout.current = setTimeout(() => {
                    // Only update if height actually changed
                    if (newHeight !== lastHeightRef.current) {
                        lastHeightRef.current = newHeight;
                        setHeight(`${newHeight}px`);
                    }
                }, 300);
            }
            else {
                try {
                    const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;

                    if (data?.data === 'authDeclined') {
                        setshowiFrame(false);
                        //console.log('Card Failed auth with code:', data.info.code);
                        Alerts.ShowAlert('Purchase Rejected', 'Card Failed auth with code: ' + data.info.code, 'info');
                    }
                } catch (error) {
                    if (!event.data.toLowerCase().includes('iframeresi')) {
                        setshowiFrame(false);
                        //console.error('Error:', error);
                        Alerts.ShowAlert('Purchase Rejected', 'Error:', error, 'info');
                    }
                }
            }
        };

        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
            }
        };



    }, [])

    function handleResponseFromComponent(response) {
        setIsValidate(response);
    }

    async function validateFields() {

        switch (arrayRegularDeposits.ImageName.toLowerCase()) {
            case "cfach":
            case "cfcashapp":
                {
                    setIsSecureIdVisible(false);
                    setIsAccountVisible(false);
                    setIsCoinflow(true);
                    setHeight('700px');
                }
                break;
            default:
                {
                    setIsSecureIdVisible(false);
                    setIsAccountVisible(true);
                }
                break;
        }
    }

    async function doCheckCustomerData() {
        await CheckCustomerData(localStorage.getItem('Token'), arrayRegularDeposits.DepositID).then(async function (response) {
            if (!response.Authentication.AllComplete) {
                setIsValidate(true);
            }
            else {
                setIsValidate(false);
            }
        })
    };

    async function doCoinflowCheckout(Amount) {
        const Data = {
            Token: localStorage.getItem('Token'),
            ProcessorName: arrayRegularDeposits.DepositName,
            CustomerId: clientInfo.CustomerID,
            AmountCents: Math.round(parseFloat(Amount) * 100),
        };

        try {
            const response = await CoinflowGetCheckoutSession(Data);
            const auth = response.Authentication;

            if (auth.Success && auth.SessionKey && auth.JwtToken) {
                setCoinflowSession({
                    sessionKey: auth.SessionKey,
                    jwtToken: auth.JwtToken,
                    merchantId: auth.MerchantId,
                    amountCents: Data.AmountCents,
                    paymentMethod: auth.PaymentMethod,   
                });
                setshowForm(false);
            } else {
                const msg = auth.Message || 'Could not start Coinflow checkout';
                if (isMobile) {
                    Alerts.ShowAlertFullScreen('Error', msg, 'error');
                } else {
                    Alerts.ShowAlert('Error', msg, 'error');
                }
            }
        } catch (error) {
            if (isMobile) {
                Alerts.ShowAlertFullScreen('Error', 'Error making Purchase', 'error');
            } else {
                Alerts.ShowAlert('Error', 'Error making Purchase', 'error');
            }
        }
    }

    if (isValidate) {
        return <MissingAccountInfo Processor={arrayRegularDeposits.DepositID} isValidate={handleResponseFromComponent.bind(isValidate)} />;
    }

    async function doEWalletDeposit(Amount, Account, SecureID) {
        let raw = localStorage.getItem('ArrayBonus');
        let arrayBonus;

        try {
            arrayBonus = raw && raw.trim() !== "" ? JSON.parse(raw) : [];
        } catch (e) {
            arrayBonus = [];
        }
        var Data =
        {
            "Token": localStorage.getItem('Token'),
            "eWalletAccount": (Account && Account.trim() !== "") ? Account : clientInfo.SkinID,
            "eWalletPassword": SecureID,
            "ProcessorName": arrayRegularDeposits.DepositName,
            "InstanceID": INSTANCEID,
            "Amount": Amount,
            "CurrencyCode": "USD",
            "returnURL": "",
            "statusURL": "",
            "TransactionID": "-1",
            "IPv4Address": clientInfo.IPAddress,
            "BonusList": BonusString(arrayBonus)
        };

        await EWalletDeposit(Data).then(function (response) {
            setIsProcessing(false);
            setshowForm(true);
            setArrayEwallet(response.Authentication);

            if (response.Authentication.ErrorCode != undefined && response.Authentication.ErrorCode != null) {

                if (isMobile) {
                    Alerts.ShowAlertFullScreen('Error with ACH Purchase', response.Authentication.ErrorDescription, 'error');
                }
                else {
                    Alerts.ShowAlert('Error with ACH Purchase', response.Authentication.ErrorDescription, 'error');
                }

            }
            else {
                var message = response.Authentication.HtmlResponse;
                if (response.Authentication.status == "PENDING") {
                    var Link = response.Authentication.Descriptor;

                    // Format dates dynamically
                    var today = new Date();
                    var availability = new Date();
                    availability.setDate(today.getDate() + 6); // 3 business days ~ 6 calendar days

                    var formatDate = (d) => {
                        var mm = String(d.getMonth() + 1).padStart(2, '0');
                        var dd = String(d.getDate()).padStart(2, '0');
                        var yyyy = d.getFullYear();
                        return `${mm}/${dd}/${yyyy}`;
                    };

                    var amount = (coinflowSession.amountCents / 100).toFixed(2);

                    message += `
                            <div style="text-align: center;">
                                <div style="font-weight: bold; font-size: 1.1em; margin-bottom: 12px;">
                                    Purchase Complete
                                </div>
                                <div>Authorized Payment Amount: $${amount}</div>
                                <div>Date Authorized: ${formatDate(today)}</div>
                                <div style="margin-top: 14px;">
                                    Bank transfer funds are available in 3 business days
                                </div>
                            </div>
                        `;

                    if (isMobile) {
                        Alerts.ShowAlertFullScreen('ACH Purchase Completed', message, 'info');
                    } else {
                        Alerts.ShowAlert('ACH Purchase Completed', message, 'info');
                    }
                }
                else if (response.Authentication.status == "REJECTED") {
                    if (isMobile) {
                        Alerts.ShowAlertFullScreen('ACH Purchase Rejected', message, 'info');
                    }
                    else {
                        Alerts.ShowAlert('ACH Purchase Rejected', message, 'info');
                    }

                }
                else {
                    // Format dates dynamically
                    var today = new Date();
                    var availability = new Date();
                    availability.setDate(today.getDate() + 6); // 3 business days ~ 6 calendar days

                    var formatDate = (d) => {
                        var mm = String(d.getMonth() + 1).padStart(2, '0');
                        var dd = String(d.getDate()).padStart(2, '0');
                        var yyyy = d.getFullYear();
                        return `${mm}/${dd}/${yyyy}`;
                    };

                    var amount = (coinflowSession.amountCents / 100).toFixed(2);

                    message += `
                        <div style="text-align: center;">
                            <div style="font-weight: bold; font-size: 1.1em; margin-bottom: 12px;">
                                ACH Payment Approved
                            </div>
                            <div>Amount: $${amount}</div>
                            <div>Date: ${formatDate(today)}</div>
                        </div>
                    `;

                    if (isMobile) {
                        Alerts.ShowAlertFullScreen('ACH Purchase Completed', message, 'info');
                    }
                    else {
                        Alerts.ShowAlert('ACH Purchase Completed', message, 'info');
                    }
                }

            }

        })
            .catch(function (error) {
                if (isMobile) {
                    Alerts.ShowAlertFullScreen('Error', 'Error making Purchase', 'error');
                }
                else {
                    Alerts.ShowAlert('Error', 'Error making Purchase', 'error');
                }

            })


    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!isProcessing) {
            var data = new FormData(event.target);
            let { amount, accountoremail, secureid } = Object.fromEntries(data.entries());
            if (amount != '') {
                setIsProcessing(true);
                await doCoinflowCheckout(amount);
                setIsProcessing(false);
            }
            else {
                Alerts.ShowAlert('Warning', 'Amount required', 'warning');
            }
        }
    }

    /*const handleIframeLoad = () => {
        try {
            setShowFrameTitle(false);
            iframeResizer({}, iframeRef.current);
        } catch (error) {
            console.warn('iframe-resizer failed to initialize, applying default height:', error);
            iframeRef.current.style.height = '700px'; // Set default height
        }
    };*/

    const handleIframeLoad = () => {
        setShowFrameTitle(false);
    }

    return (
        <div className="componentload">
            <form onSubmit={handleSubmit}>
                <div className="row m-4">
                    <span className="icon-single-left txt-primary">
                        <img style={{ width: "100px", height: "100px", }} src={"/svg/" + arrayRegularDeposits.ImageName + ".svg"} /> Deposit using {id}
                    </span>
                </div>
                {showiFrame && <div>
                    {showFrameTitle && <h5 id="frameTitle">Please wait, your form will load in a few seconds...</h5>}

                    { /*onLoad={handleIframeLoad}*/}
                    <iframe
                        ref={iframeRef}
                        style={{ overflow: "scroll" }}
                        onLoad={handleIframeLoad}
                        src={arrayEwallet.Descriptor}
                        height={height}
                        width='100%'
                        scrolling="yes"
                        allow="payment; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture full">
                    </iframe>
                </div>}
                {showForm && <div >
                    <div className="row">
                        <div className="col-md-12 col-sm-12">
                            <div className="row">
                                {isSecureIdVisible && <div className="col-md-12 clear row-12" >
                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                        <label for="secureid" className="col-md-offset-3 col-md-2  col-sm-offset-3 col-sm-2 col-xs-12">SecureID:</label>
                                        <div className="col-md-7 col-sm-7 col-xs-12">
                                            <input type="password" className="form-control" name="secureid"
                                                aria-label="secure id" placeholder="SecureID" required />
                                        </div>
                                    </div>
                                </div>}
                                {isAccountVisible && <div className="col-md-12 clear row-12 mb-4">
                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                        <label for="secureid" className="col-md-offset-3 col-md-2  col-sm-offset-3 col-sm-2 col-xs-12">Account:</label>
                                        <div className="col-md-7 col-sm-7 col-xs-12">
                                            <input type="text" className="form-control" name="accountoremail"
                                                aria-label="account or email" placeholder="Account" required />
                                        </div>
                                    </div>
                                </div>}
                                <div className="col-md-7 col-sm-7 col-xs-12">
                                    <div className="col-md-12 m-3 ">

                                        <div className="input-group mb-3  ">
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-currency-cards d-none d-md-block" id="lblCurrency">
                                                        <select className="form-control selectcurrency" disabled name="CurrencyCode" required value={clientInfo.CurrencyCode == 'mBTC' ? 'USD' : clientInfo.CurrencyCode}>
                                                            <option value="" className="">Currency</option>
                                                            <option selected value="USD">USD</option>
                                                            <option value="EUR">EUR</option>
                                                            <option value="GBP">GBP</option>
                                                            <option value="CAD">CAD</option>
                                                        </select>
                                                    </span>
                                                </div>
                                                <input type="number" onKeyPress={(event) => onlyNumbers(event)} aria-label="Amount (to the nearest dollar)" className="form-control" id="amount" aria-describedby="lblCurrency" placeholder="Enter amount here" max={arrayRegularDeposits?.MaxDeposit === 0 ? MAXLIMIT : arrayRegularDeposits?.MaxDeposit} min={arrayRegularDeposits?.MinDeposit === 0 ? 1 : arrayRegularDeposits?.MinDeposit} name="amount" required="" />
                                            </div>
                                        </div>
                                        <div className="d-flex flex-row ml-2 limit-text-center mb-4 ">
                                            Purchase Limits: Minimum {arrayRegularDeposits.MinDeposit == 0 ? 1 : arrayRegularDeposits.MinDeposit} USD Maximum {arrayRegularDeposits.MaxDeposit == 0 ? 'No Limit' : arrayRegularDeposits.MaxDeposit + ' USD'}
                                        </div>
                                    </div>

                                </div>
                                <Bonus ProcessorName={id} />
                            </div>
                        </div>

                    </div>

                </div>}

                {coinflowSession && (
                    <div className="row m-4" style={{ height: '600px' }}>
                        <CoinflowPurchase
                            sessionKey={coinflowSession.sessionKey}
                            merchantId={coinflowSession.merchantId}
                            env={process.env.REACT_APP_CoinflowEnv || 'prod'}
                            subtotal={{ cents: coinflowSession.amountCents, currency: 'USD' }}
                            email={clientInfo.Email}
                            allowedPaymentMethods={[coinflowSession.paymentMethod]}
                            jwtToken={coinflowSession.jwtToken}
                            onSuccess={(...args) => {
                                setCoinflowSession(false);
                                setIsProcessing(true);
                                const { paymentId } = args[0] || {};
                                console.log('local', ...args);
                                doEWalletDeposit(coinflowSession.amountCents / 100, paymentId, '');
                            }}
                        />
                    </div>
                )}
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12 " >

                    </div>
                    <div className="col-md-12 mb-3-small mt-4 actionbuttons">
                        <button type="button" className="btn btn-secondary btn-gray btn-back-order mb-4" onClick={() => navigate('/deposits/')}>BACK</button>
                        {(!showiFrame && !coinflowSession) &&
                            <button type="submit"
                                className="btn btn-deposit btn-deposit-order mb-4 submit"
                                disabled={isProcessing}>{isProcessing ? "Processing..." : "PURCHASE"}</button>
                        }
                    </div>
                </div>
            </form >
            <div>
                {isProcessing && <Loading />}
            </div>
        </div>

    );
}